import React, { Component } from "react";

import dayjs from "dayjs";

const styles = {
  document: {
    color: "#000000",
    fontFamily: "sans-serif",
    fontSize: "9pt",
  },
  title: {
    fontSize: "16pt",
    margin: "0 0 16pt",
    textAlign: "center",
  },
  table: {
    borderCollapse: "collapse",
    fontSize: "8pt",
    width: "100%",
  },
  columnHeader: {
    backgroundColor: "#afaeae",
    border: "1px solid #000000",
    padding: "4pt",
    textAlign: "left",
    verticalAlign: "middle",
  },
  amountHeader: {
    backgroundColor: "#afaeae",
    border: "1px solid #000000",
    padding: "4pt",
    textAlign: "right",
    verticalAlign: "middle",
  },
  cell: {
    border: "1px solid #000000",
    padding: "3pt",
    verticalAlign: "top",
  },
  amountCell: {
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  totalLabelCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
  },
  totalAmountCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
};

export default class ListeQuittancementPDF extends Component {
  render() {
    const { quittances } = this.props;

    const total = quittances.reduce((a, b) => a + parseFloat(b.montant), 0);

    return (
      <div style={styles.document}>
        {/* TITRE DOCUMENT */}
        <div style={styles.title}>
          <strong>{`LISTE RÉCAPITULATIVE DU QUITTANCEMENT DU ${dayjs().format(
            "DD/MM/YYYY"
          )}`}</strong>
        </div>

        {/* LIGNES QUITTANCES */}
        <table style={styles.table}>
          <thead>
            <tr>
              <th width="50%" style={styles.columnHeader}>
                <strong>Locataire</strong>
              </th>
              <th width="15%" style={styles.columnHeader}>
                <strong>Date début</strong>
              </th>
              <th width="15%" style={styles.columnHeader}>
                <strong>Date fin</strong>
              </th>
              <th width="20%" style={styles.amountHeader}>
                <strong>Montant</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            {quittances.map((ligne, i) => {
              return (
                <tr
                  key={i}
                  style={{ backgroundColor: i % 2 === 0 ? "#ffffff" : "#eeeeee" }}
                >
                  <td width="50%" style={styles.cell}>
                    {ligne.locataire.locataire_code} {" "}
                    {ligne.locataire.locataire_personne.personne_nom} {" "}
                    {ligne.locataire.locataire_personne.personne_prenom}
                  </td>
                  <td width="15%" style={styles.cell}>
                    {`${dayjs(ligne.date_debut).format("DD/MM/YYYY")}`}
                  </td>
                  <td width="15%" style={styles.cell}>
                    {`${dayjs(ligne.date_fin).format("DD/MM/YYYY")}`}
                  </td>
                  <td width="20%" style={styles.amountCell}>
                    {parseFloat(ligne.montant).toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan="3" width="80%" style={styles.totalLabelCell}>
                <strong>{`Total quittancement (${quittances.length} locataires)`}</strong>
              </th>
              <td width="20%" style={styles.totalAmountCell}>
                <strong>
                  {parseFloat(total).toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  })}
                </strong>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}
